module.exports = __webpack_public_path__ + "img/FSC_Hand_artemis.abbb21d0.svg";